<fi-header [projectName]="title()" [username]="(user | async)?.name" [icons]="userIcon">
  <ng-container header-content>
    <p-menubar class="header-menu" [model]="items" />
    @if (isWorkspaceManagementVisible()) {
      <div class="workspace-wrapper" [class.has-unsaved-changes]="hasUnsavedChanges()" (click)="workspacePopover.toggle($event)">
        {{selectedLayout()?.label}}
        <i class="pi pi-desktop" pTooltip="Workspace Management"></i>
      </div>
    }
  </ng-container>
</fi-header>
<router-outlet />
<p-toast preventOpenDuplicates />
<fi-spinner />
<p-popover #userInfoPopover styleClass="popover-in-header">
  @if (loggedIn()) {
    <app-user-preferences />
  }
</p-popover>
<p-popover #workspacePopover styleClass="popover-in-header">
  <fi-workspace-management [workspaceKey]="'issuer'"
                           [baseKey]="'IssuerWorkspaceConfiguration'"
                           [title]="'Workspace Management'"
                           [settingsList]="null"
                           [enableShareWithUsers]="false"
                           [enableGrouping]="false"
                           [enableGlobalConfigs]="false"
                           [isAutosaveEnabled]="false"
                           (handleLayoutSelection)="onLayoutChange($event)"
                           (handleSaveLayoutClick)="saveLayout()"
                           (handleLayoutResetClick)="resetLayoutChanges()"
                           (handleSettingsChange)="onSettingsChange($event)"
                           (handleNewConfigurationSave)="createNewConfig($event)"/>
</p-popover>

<fi-session-timeout />
<p-confirmDialog />
